import { useEffect } from 'react'; 
import DynamicTableInput from './DynamicTableInputCopy.jsx'; 
import redMinusIcon from '../../svgs/delete-bin-icon.svg';
import addIcon from '../../svgs/plus-icon.svg';

import { Button, TableCell, Typography } from '@mui/material';

const InputTableRow = ({ data, setData, count, config, length, setLength, lists, error, setError, onEditClick=()=>{return}, enableEdit=false, show=true ,addButtonText = 'Add'}) => {
    // event handler to add row to table 
    const addRow = () => {
        // create header object
        let temp2 = []; 
        for (let i = 0; i < config.length; i++){
            temp2.push(config[i]['columnid']);
        }
        // create object
        let temp = {};
        temp2.map((el) => {
            if (el == 'blank'){
                temp[el] = false;
            }
            else if (el == 'active'){
                temp[el] = lists['active'][0];
            }
            else if (el == 'startdate') {
                temp[el] = new Date(); 
            }
            else{
                temp[el] = '';
            }
        });
        // assign object to state 
        let tempObj = data; 
        // move bottom row to end of object
        tempObj[(count+1)] = data[count]; 
        // set new element 
        data[count] = temp; 
        setData(data => data = tempObj);
        // set error object 
        let temp5 = {}
        Object.keys(temp2).map((el) => {
            temp5 = {
                ...temp5, 
                el: false, 
            }
        }); 
        // add error object to sub company error list 
        setError(error => error = [
            ...error.slice(0, error.length-1), 
            temp5, 
            ...error.slice(error.length-1, error.length)
        ]); 
        // increment length
        setLength(length => length = length + 1); 
    }

    // event handler for remove row from table
    const removeRow = () => {
        // set tempObj to make changes
        let tempObj = data; 
        // remove row at count
        let length = 0; 
        Object.keys(tempObj).map(el => {
            let num = parseInt(el); 
            // set length; 
            length = num; 
            // overwrite element
            if (tempObj[(num+1)] && num >= count) {
                tempObj[num] = tempObj[(num+1)]; 
            }
        }); 
        // remove last element 
        delete tempObj[length]; 
        // set state 
        setData(data => data = tempObj); 
        // update length
        setLength(length => length = length-1); 
        // remove error object from error list
        setError(error => error = [...error.slice(0, count), ...error.slice(count + 1, error.length)]); 
    }

    useEffect(() => {
        console.log(data); 
    }, [data]); 
    
    // render component
    return(
        <>
            {/* order columns according to config object */}

            { config && data[count] ? 
                config.map(el =>
                show && el['columnid'] != 'blank' && data[count]['blank'] != true ?
                <TableCell>
                    {console.log(count + ': ' + error[count])}
                    <DynamicTableInput 
                        count={count}
                        length={length}
                        data={data} 
                        setData={setData} 
                        config={el} 
                        args={lists} 
                        width={'100%'} 
                        showError={error[count][el['columnid']]}
                        onChangeFunction={()=>{return}}
                    />
                </TableCell>
                : show && el['columnid'] == 'blank' && data[count]['overrideblank'] !== true && data[count]['blank'] == true ? 
                <TableCell colSpan={config.length} align='center' sx={{padding:0}}>
                    <div className='p-2 bg-white'>
                        <Button disableRipple onClick={()=>addRow()} 
                        sx={{width:'100%', background:'#E5F2F6' ,border:'#E5F2F6','&:hover': {
                            backgroundColor: '#D9ECF2',
                            },
                            }}
                        >
                            {<div className='d-flex gap-2 align-items-center p-1'>
                                <img src={addIcon}/>
                                <Typography sx={{
                                    textTransform:'none',
                                    color:'#001317',
                                    fontFamily:'Roboto regular, Helvetica, Arial, sans-serif',
                                    fontSize:'12px',
                                    lineHeight:'16px',
                                    fontWeight:'400'}}>
                                        {addButtonText}
                                </Typography>
                            </div>}
                        </Button>
                    </div>          
                </TableCell>
                :show && el['columnid'] == 'blank' && data[count]['overrideblank'] !== true && data[count]['blank'] != true ?
                <TableCell>
                    <img src={redMinusIcon} class='data-table-icon-right' onClick={()=>removeRow()}/>
                </TableCell>
                :show && el['columnid'] == 'blank' && data[count]['overrideblank'] == true && data[count]['blank'] != true ?
                    <TableCell></TableCell> // TODO: Check this condition
                :<></>
            )
            :<TableCell></TableCell>}
        </>
    ); 
}

export default InputTableRow; 